import { render, staticRenderFns } from "./SummaryLastGame.vue?vue&type=template&id=09ff2504&scoped=true&"
import script from "./SummaryLastGame.vue?vue&type=script&lang=js&"
export * from "./SummaryLastGame.vue?vue&type=script&lang=js&"
import style0 from "./SummaryLastGame.vue?vue&type=style&index=0&id=09ff2504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff2504",
  null
  
)

export default component.exports